import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  payment_id: "",
  delivery_id: "",
  delivery_address: "",
  notes: "",
  now: "",
  phone_number: "",
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (prevState, action) => {
      const exsistIdx = prevState.list.findIndex(
        (item) =>
          item.product_id === action.payload.product_id &&
          deepEqual(item.modifiersSelected, action.payload.modifiersSelected)
        // &&
        // item.modifiersSelected === action.payload.modifiersSelected
      );

      console.log("Cart List:", JSON.parse(JSON.stringify(prevState.list)));

      console.log(action.payload.modifiersSelected);
      console.log(exsistIdx);

      function deepEqual(obj1, obj2) {
        if (obj1 === obj2) {
          return true;
        }

        if (
          typeof obj1 !== "object" ||
          typeof obj2 !== "object" ||
          obj1 === null ||
          obj2 === null
        ) {
          return false;
        }

        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
          return false;
        }

        for (const key of keys1) {
          if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
            return false;
          }
        }

        return true;
      }

      const updatedItem = {
        ...action.payload,
        qty:
          exsistIdx !== -1
            ? prevState.list[exsistIdx].qty + action.payload.qty
            : action.payload.qty,
        subtotal:
          exsistIdx !== -1
            ? prevState.list[exsistIdx].subtotal + action.payload.subtotal
            : action.payload.subtotal,
      };

      const updatedCart =
        exsistIdx !== -1
          ? [
              ...prevState.list.slice(0, exsistIdx),
              updatedItem,
              ...prevState.list.slice(exsistIdx + 1),
            ]
          : [...prevState.list, updatedItem];

      return {
        ...prevState,
        list: updatedCart,
      };
    },
    incrementQty: (prevState, action) => {
      return {
        ...prevState,
        list: prevState.list.map((item) => {
          if (
            item.product_id === action.payload.product_id &&
            item.time === action.payload.time
          ) {
            return {
              ...item,
              qty: item.qty + 1,
              subtotal: item.subtotal + item.price,
            };
          }
          return item;
        }),
      };
    },
    decrementQty: (prevState, action) => {
      return {
        ...prevState,
        list: prevState.list.map((item) => {
          if (
            item.product_id === action.payload.product_id &&
            item.time === action.payload.time
          ) {
            if (item.qty === 1) {
              return item;
            }
            return {
              ...item,
              qty: item.qty - 1,
              subtotal: item.subtotal + item.price,
            };
          }
          return item;
        }),
      };
    },
    removeFromCart: (prevState, action) => {
      console.log(action.payload);
      return {
        ...prevState,
        list: prevState.list.filter((item) => {
          return !(
            item.product_id === action.payload.product_id &&
            item.time === action.payload.time
          );
        }),
      };
    },
    resetCart: (prevState, action) => {
      return { ...prevState, ...initialState };
    },
    setDelivery: (prevState, action) => {
      return {
        ...prevState,
        ...action.payload,
      };
    },
  },
});

export const cartActions = cartSlice.actions;
export default cartSlice.reducer;
